export const REGEX = {
	EMAIL: /^[\w.%+-]+@(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,}$/i,
	PHONE: /^[\-+\(\) ]*[0-9][\-+\(\) 0-9]*$/,
	NICKNAME_ALPHA_NUMERIC_SPECIAL_CHAR: /^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9](?:[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9 ]*[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9])?$/,
	CARD_NUMBER_MASK: /[0-9](?=([0-9]{4}))/g,
	IDENTIFICATION: /^\d+$/,
	SEARCH_REDIRECT_SUFFIX: /[&]?\*=$/,
	ALPHA_NUMERIC_SPECIAL_CHAR: /^[a-zA-Z0-9](?:[a-zA-Z0-9 ]*[a-zA-Z0-9])?$/,
	SPANISH_ALPHA_NUMERIC: /^[-A-Za-zñÑáéíóúÁÉÍÓÚüÜ0-9´\s]+$/g,
	SPANISH_NAME: /^[A-Za-zñÑáéíóúÁÉÍÓÚ0´\s]+$/,
	NUMERIC: /^[0-9]+$/,
	LAT_LNG_FORMAT: /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/,
};
